import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";
// import test from '../http-common';
// import api from "./../http-common";

//

// const BASE_SOCIETE_URL = "http://localhost:8082/gateway/finance/Societe"

// const BASE_SOCIETE_URL = "http://192.168.1.112:8082/gateway/finance/Societe"

// ,"Access-Control-Allow-Origin": "*","Access-Control-Allow-Credentials": "true","Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS","Access-Control-Allow-Headers": "Origin,Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
const header = { Authorization: "Bearer " + sessionStorage.getItem("Token") };
class SocieteService {
  addSociete(societe) {
    return api.post(UtilsUrl.societeURL() + "/addSociete", societe, {
      headers: header,
    });
  }
  addContact(user) {
    return api.post(UtilsUrl.SocieteContactURL() + "/addContact", user, {
      headers: header,
    });
  }

  getSocietesContacts(idUser, idSociete) {
    return api.get(
      UtilsUrl.SocieteContactURL() +
        "/getListContactSociete/" +
        idUser +
        "/" +
        idSociete
    );
  }

  deleteAndRestoreContact(idUser, isDeleted) {
    return api.get(
      UtilsUrl.SocieteContactURL() +
        "/deleteAndRestoreContact/" +
        idUser +
        "/" +
        isDeleted
    );
  }

  updateSociete(societe) {
    return api.post(UtilsUrl.societeURL() + "/updateSociete", societe, {
      headers: header,
    });
  }
  getSocietesClients(idUser, typeSociete, typeClient, isActive, isDeleted) {
    return api.get(
      UtilsUrl.societeURL() +
        "/getListSociete/" +
        idUser +
        "/" +
        typeSociete +
        "/" +
        typeClient +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
  // these two are served by retail-erp (SocieteRestApi); there is no finance microservice
  getSocieteById(idSociete) {
    return api.get("/retail/SocieteRestApi/getSocieteById/" + idSociete);
  }
  getSocieteByIdUser(idUser) {
    return api.get("/retail/SocieteRestApi/getSocieteByIdUser/" + idUser);
  }

  allSocieteTypeClient(typeSociete, typeClient, idUser, isActive, isDeleted) {
    return api.get(
      UtilsUrl.societeURL() +
        "/allSocieteTypeClient/" +
        typeSociete +
        "/" +
        typeClient +
        "/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
  getFinacialYearsAndMonthsFromSocieteCreationDate(idUser) {
    return api.get(
      UtilsUrl.societeURL() +
        "/getFinacialYearsAndMonthsFromSocieteCreationDate/" +
        idUser
    );
  }
  testSocieteClient(idSociete, typeClient, idUser) {
    return api.get(
      UtilsUrl.societeURL() +
        "/testSocieteClient/" +
        idSociete +
        "/" +
        typeClient +
        "/" +
        idUser
    );
  }

  changerTypeClientSociete(idUser, idSociete, typeClient) {
    return api.get(
      UtilsUrl.societeURL() +
        "/changerTypeClientSociete/" +
        idSociete +
        "/" +
        typeClient
    );
  }
  supprimer(idSociete) {
    return api.get(UtilsUrl.societeURL() + "/supprimerSociete/" + idSociete);
  }
 
}
export default new SocieteService();
